export enum MailingListToUserStatusEnum {
	Pending = '576e7021-58ea-4775-a362-c530853e0abc',
	Sent = '19034c05-9cfd-41dc-b28e-59f8b578459b',
}
